/// <amd-module name="VSS/Features/Frame/ContributedIconUtil" />
import { IVssPageContext } from "VSS/Platform/Context";
import { css } from "VSS/Platform/Layout";
import { format } from "VSS/Core/Util/String";
import { combineUrlPaths } from "VSS/Platform/Util/Url";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssThemeService } from "VSS/Platform/Theming";
import { IIconProps } from "VSSUI/Icon";
import { IContributedIconDefinition } from "VSS/Platform/ContributionTypes";

export function contributionIconToIconProps(
    pageContext: IVssPageContext,
    contributionId: string,
    icon: string | IContributedIconDefinition | undefined
): IIconProps | undefined {
    let iconProps: IIconProps | undefined;

    if (icon) {
        let iconUrl: string | undefined;
        let nonThemed = true;

        if (typeof icon === "object") {
            const theme = pageContext.getService<IVssThemeService>("IVssThemeService").getCurrentTheme();
            const key = theme && theme.isDark ? "dark" : "light";
            icon = icon[key];
            nonThemed = false;
        }

        if (icon.match(/^https?:\/\//)) {
            iconUrl = icon;
        } else {
            const contributionSvc = pageContext.getService<IVssContributionService>("IVssContributionService");
            const provider = contributionSvc.getContributionProvider(contributionId);
            if (provider) {
                iconUrl = combineUrlPaths(provider.baseUri, icon);
            }
        }

        if (iconUrl) {
            iconProps = {
                iconName: "None",
                className: css("icon third-party-icon contributed-icon-image", nonThemed && "non-themed"),
                style: {
                    backgroundImage: format("url({0})", iconUrl),
                    backgroundRepeat: "no-repeat"
                }
            };
        }
    }

    return iconProps;
}
